import { Loader2 } from "lucide-react";

export default function Loader() {
	return (
		<output
			aria-busy="true"
			aria-label="Loading content"
			className="flex h-full items-center justify-center pt-8"
		>
			<Loader2 className="animate-spin motion-reduce:animate-none" />
			<span className="sr-only">Loading...</span>
		</output>
	);
}
